module.exports = __webpack_public_path__ + "static/media/chevron-left.10ae05c7.svg";